import React, { useMemo, useState, useEffect, useRef } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import '../../Style/EditModal.scss';
import "../../Style/TableStyle.scss"
import '../../Style/__searchbar.scss'
import '../../Style/__button.scss'
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { errorAlert, handleSuccess, updateAlert } from "../../Components/Alerts";
import { Typography, Modal } from '@mui/material';
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import { AiFillEdit } from "react-icons/ai";
// import { jsPDF } from "jspdf";
import "jspdf-autotable";
import LoginUserDetailed from '../../Auth/LoginUserDetailed';
import { MdAddBusiness } from "react-icons/md";
import Box from '@mui/material/Box';
import FormControl from "@mui/material/FormControl";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import MUI_Button from "@mui/material/Button";
import AddIcon from '@mui/icons-material/Add';
import { AddElementsButton } from "../../Components/AddElementsButton";
import CrudPageHeader from "../../Components/CrudPageHeader";
import ReusableServerDataGrid from "../../Components/ReusableServerDataGrid";

export default function CompaniesPage() {

    const headers = authHeader();
    const history = useHistory();
    const loginEmail = LoginUserDetailed();
    const [data, setData] = useState([]);
    const [formData, setFormData] = useState({
        CompanyID: "",
        CompanyName: "",
        IdentificationNumber: "",
        VATNumber: "",
        Address: "",
        CityID: "",
        StateID: "",
        PhoneNumbers: "",
        EdiPass: "",
        ARBKPass: "",
        MailPass: "",
        SMTPClient: "",
        Email: "",
        Comment: "",
        ModifiedByUser: "",
        VATDeclarant: "",
        FiscalYear: "",
        IsActive: "",
        CompanyLogo: "anonymous.png",
        LogoPath: ApiLink.PHOTO_URL
    })

    const [openPackModal, setOpenPackModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [city, setCity] = useState([]);
    const [state, setState] = useState([]);
    let number = 1;
    const [role, setRole] = useState("");

    const [insertType, setInsertType] = useState("");

    const [pack, setPack] = useState([]);
    const [companyName, setCompanyName] = useState('');
    const [companyID, setCompanyID] = useState('');
    const [packID, setPackID] = useState('');
    const [packName, setPackName] = useState('');
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 50 });
    const [sortModel, setSortModel] = useState([]);
    const [filterModel, setFilterModel] = useState({ items: [] });
    const [quickFilter, setQuickFilter] = useState([]);

    const fetchData = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Companies', { headers });
            setData(response.data);
            setLoading(false);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);

            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    // const fetchData = async () => {
    //     try {
    //         const response = await axios.get(ApiLink.API_URL + 'Companies/getCompanyAndLicense', { headers });
    //         const data = response.data;

    //         // Shembull: nëse ke një company object me licenseStatusId dhe paymentStatusId
    //         const mappedData = data.map((item) => {
    //             return {
    //                 ...item,
    //                 licenseStatus: item.Status
    //                     ? (LICENSE_STATUS.find(s => s.id === item.Status)?.label ?? "Nuk ka licens")
    //                     : "Nuk ka licens",

    //                 paymentStatus: item.PaymentStatus
    //                     ? (PAYMENT_STATUS.find(s => s.id === item.PaymentStatus)?.label ?? "Nuk ka licens")
    //                     : "Nuk ka licens",

    //             };
    //         });

    //         setData(mappedData);
    //         setLoading(false);

    //     } catch (error) {
    //         errorAlert("Gabim në kërkesë:", error);

    //         if (error.response?.data?.errorMessage) {
    //             errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
    //         } else if (error.message) {
    //             errorAlert(`Gabim: ${error.message}`);
    //         } else {
    //             errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
    //         }
    //     }
    // };

    const fetchPack = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'PackContoller', { headers });
            setPack(response.data);
            setLoading(false);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);

            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    // const handleSubmitCompanyPack = (event) => {
    //     event.preventDefault();

    //     // Validimi i `packID` dhe `companyID`
    //     if (!packID || packID === '') {
    //         errorAlert("Ju lutem zgjedhni pakon");
    //         return;
    //     }
    //     if (!companyID || companyID === '') {
    //         errorAlert("Ju lutem zgjedhni kompaninë");
    //         return;
    //     }

    //     const stateData = {
    //         CompanyID: companyID,
    //         PackID: packID
    //     };

    //     axios.post(ApiLink.API_URL + 'PackContoller', stateData, { headers })
    //         .then((response) => {
    //             handleSuccess("Pako u regjistrua me sukses tek kompania");
    //             setPackID("");
    //             setCompanyID("");
    //             setOpenPackModal(false);
    //             fetchData();
    //         })
    //         .catch((error) => {
    //             if (error.response) {
    //                 if (error.response.status === 409) {
    //                     errorAlert(error.response.data);
    //                 } else if (error.response.status === 400) {
    //                     errorAlert("Të dhënat janë të pavlefshme. Ju lutem kontrolloni dhe provoni përsëri.");
    //                 } else if (error.response.status === 500) {
    //                     errorAlert("Gabim serveri. Ju lutem provoni më vonë.");
    //                 }
    //             } else {
    //                 errorAlert("Gabim i panjohur ndodhi gjatë përpunimit të kërkesës.");
    //             }
    //         });
    // };

    const handleUpdateCompanyPack = (companyID, pack, type) => {
        // Kontrollo validimin e të dhënave hyrëse
        if (!companyID || !pack) {
            errorAlert("Ju lutem plotësoni të gjitha fushat.");
            return;
        }

        const updateData = {
            CompanyID: companyID,
            Pack: pack
        };

        // axios.put(ApiLink.API_URL + 'PackContoller', updateData, { headers })
        axios.put(`${ApiLink.API_URL}${type === "pack" ? 'PackContoller' : 'PackContoller/module'}`, updateData, { headers })
            .then((response) => {
                if (response.status === 200) {
                    // handleSuccess(response.data); // Shfaq mesazhin e suksesit
                    setPack("");
                    setCompanyID("");
                    setOpenPackModal(false);
                    fetchData();
                }
            })
            .catch((error) => {
                if (error.response) {
                    if (error.response.status === 400) {
                        errorAlert("Të dhënat janë të pavlefshme. Ju lutem kontrolloni dhe provoni përsëri.");
                    } else if (error.response.status === 500) {
                        errorAlert("Gabim serveri. Ju lutem provoni më vonë.");
                    } else {
                        errorAlert("Gabim i panjohur: " + error.response.data);
                    }
                } else {
                    errorAlert("Nuk mund të lidhemi me serverin. Ju lutem provoni më vonë.");
                }
            });
    };

    const executeUpdatePack = (e, type) => {
        e.preventDefault();

        if (type === "pack") {
            handleUpdateCompanyPack(companyID, packName, "pack");
        } else {
            handleUpdateCompanyPack(companyID, packName, "module");
        }
    };


    //Per ta zgjedhur njesin e kompanis
    const handleAutocompleteChangePack = (event, value) => {
        if (value) {
            setPackID(value.PackID);
            setPackName(value.PackName);
        } else {
            setPackID("");
            setPackName('');
        }
    };

    const defaultPropsPack = {
        options: pack,
        getOptionLabel: (option) => option.PackName || ""
    };

    //Kodi per shfaqjen e tabeles ne Print
    const tableRef = useRef();

    //Kodi per pegination ne tabel
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    //Kodi per dizajnin e tabeles
    const styles = {
        tableHeader: {
            backgroundColor: '#284945',
            color: 'white',

        },
        tableCell: {
            paddingTop: '1px',
            paddingBottom: '1px',

        },

    };
    //Kodi per shfaqjen e loadingut 
    const [loading, setLoading] = useState(true);

    //Kodi per shfaqjen e formes per editimin e te dhenave ne databaz 
    const handleEdit = (item) => {
        history.push(`/configuration/newCompany/edit/${item.CompanyID}`, {
            mode: "edit",
            companyId: item.CompanyID,
        });
    };

    // Kodi per ruajtjen e te dhenave pas editimint 
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
    };
    //Dergimi i kerkeses per editimin e te dhenave ne backend 
    const handleSubmit = (event) => {
        event.preventDefault();
        if (!formData.IdentificationNumber) {
            errorAlert("Ju lutem plotësoni numrin Identifikues")
        }
        else {
            const headers = authHeader();
            axios
                .put(ApiLink.API_URL + 'Companies', formData, { headers })
                .then((response) => {
                    setShowEditModal(false); // Close the edit modal
                    fetchData();
                    updateAlert("Kompania është editua me sukses");
                })
                .catch((error) => {
                    // alert("Failed to update State");
                    errorAlert("Kompania nuk është edituar")
                });
        }
    };

    // const imageUpload = (e) => {
    //     e.preventDefault();

    //     // Kontrollo nëse files janë të definuara dhe ka një element në pozitën '0'
    //     if (e.target.files && e.target.files.length > 0) {
    //         const fileData = new FormData();
    //         fileData.append("file", e.target.files[0], e.target.files[0].name);

    //         axios.post(ApiLink.API_URL + 'Companies/SaveFile', fileData, { headers })
    //             .then((response) => {
    //                 setFormData({
    //                     ...formData,
    //                     CompanyLogo: response.data,
    //                 });
    //             })
    //             .catch((error) => {
    //                 console.error(error);
    //             });
    //     }
    // };

    const [showLogoAlert, setShowLogoAlert] = useState(false);
    const [showLogoTxt, setShowLogoTxt] = useState("");
    const imageUpload = (e) => {
        e.preventDefault();

        const file = e.target.files[0];
        if (!file) return;

        // Lista e ekstensioneve të lejuara për imazhe
        const allowedExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
        const fileExtension = file.name.split('.').pop().toLowerCase();

        // Kontrollo extensionin
        if (!allowedExtensions.includes(fileExtension)) {
            setShowLogoAlert(true);
            setShowLogoTxt('Ju lutem zgjidhni një file të vlefshëm të fotos (jpg, jpeg, png, gif, bmp, webp)');
            e.target.value = ''; // Pastron inputin
            return;
        }
        else {
            setShowLogoAlert(false);
            setShowLogoTxt("");
        }

        // Kontrollo edhe tipin MIME për më shumë siguri
        if (!file.type.startsWith("image/")) {
            setShowLogoAlert(true);
            setShowLogoTxt('File duhet të jetë një foto.');
            e.target.value = '';
            return;
        }
        else {
            setShowLogoAlert(false);
            setShowLogoTxt("");
        }

        const fileData = new FormData();
        fileData.append("file", file, file.name);

        axios.post(ApiLink.API_URL + 'Companies/SaveFile', fileData, { headers })
            .then((response) => {
                setFormData({
                    ...formData,
                    CompanyLogo: response.data,
                });
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const fetchRole = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'AuthProva/getrole', { headers });

            if (response.data.UserRole && response.data.UserRole !== undefined) {
                setRole(response.data.UserRole);
            } else {
                errorAlert("Undefined Role.");
            }
        } catch (error) {
            console.error("Error fetching role:", error);
            // ... (pjesa tjetër e kodit)
        }
    };


    const filteredData = useMemo(() => {
        const quickSearch = String(quickFilter?.[0] || searchTerm || "").trim().toLowerCase();
        let rows = [...data];

        if (quickSearch) {
            rows = rows.filter((item) => {
                const searchableText = [
                    item.CompanyName,
                    item.IdentificationNumber,
                    item.VATNumber,
                    item.Address,
                    item.FiscalYear,
                    item.Pack,
                    item.IsActive ? "aktive" : "jo aktive",
                ]
                    .filter(Boolean)
                    .join(" ")
                    .toLowerCase();

                return searchableText.includes(quickSearch);
            });
        }

        (filterModel?.items || []).forEach((filterItem) => {
            const value = String(filterItem.value || "").trim().toLowerCase();
            if (!filterItem.field || !value) {
                return;
            }

            rows = rows.filter((item) => {
                const cellValue = String(item[filterItem.field] ?? "").toLowerCase();
                if (filterItem.operator === "equals") {
                    return cellValue === value;
                }

                return cellValue.includes(value);
            });
        });

        const activeSort = sortModel?.[0];
        if (activeSort?.field) {
            rows.sort((left, right) => {
                const leftValue = left?.[activeSort.field];
                const rightValue = right?.[activeSort.field];

                const leftText = leftValue === null || leftValue === undefined ? "" : String(leftValue).toLowerCase();
                const rightText = rightValue === null || rightValue === undefined ? "" : String(rightValue).toLowerCase();

                if (leftText < rightText) return activeSort.sort === "desc" ? 1 : -1;
                if (leftText > rightText) return activeSort.sort === "desc" ? -1 : 1;
                return 0;
            });
        }

        return rows;
    }, [data, quickFilter, searchTerm, filterModel, sortModel]);

    const pagedData = useMemo(() => {
        const start = paginationModel.page * paginationModel.pageSize;
        return filteredData.slice(start, start + paginationModel.pageSize);
    }, [filteredData, paginationModel]);

    const companyGridColumns = useMemo(() => ([
        {
            field: 'CompanyID',
            headerName: '#',
            minWidth: 70,
            flex: 0.5,
            filterable: false,
            headerClassName: 'super-app-theme--header',
        },
        {
            field: 'CompanyName',
            headerName: 'Emri i Kompanisë',
            minWidth: 180,
            flex: 1.6,
            headerClassName: 'super-app-theme--header',
        },
        {
            field: 'IdentificationNumber',
            headerName: 'Numri Identifikues',
            minWidth: 130,
            flex: 1.1,
            headerClassName: 'super-app-theme--header',
        },
        {
            field: 'VATNumber',
            headerName: 'Numri i TVSH-së',
            minWidth: 120,
            flex: 1,
            headerClassName: 'super-app-theme--header',
        },
        {
            field: 'Address',
            headerName: 'Adresa',
            minWidth: 160,
            flex: 1.4,
            headerClassName: 'super-app-theme--header',
        },
        {
            field: 'FiscalYear',
            headerName: 'Viti Fiskal',
            minWidth: 100,
            flex: 0.85,
            headerClassName: 'super-app-theme--header',
        },
        {
            field: 'Pack',
            headerName: 'Pako',
            minWidth: 140,
            flex: 1.1,
            headerClassName: 'super-app-theme--header',
            renderCell: ({ row }) => (
                role === "acctree" ? (
                    <>
                        {row.Pack ? (
                            <span>{row.Pack}</span>
                        ) : (
                            <Tooltip title="Cakto Pakon" placement="left">
                                <IconButton
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        setInsertType("pack");
                                        setOpenPackModal(true);
                                        setCompanyName(row.CompanyName);
                                        setCompanyID(row.CompanyID);
                                    }}
                                >
                                    <AddIcon style={{ color: '#284945' }} />
                                </IconButton>
                            </Tooltip>
                        )}
                    </>
                ) : (
                    <span>{row.Pack}</span>
                )
            ),
        },
        {
            field: 'statusLabel',
            headerName: 'Statusi',
            minWidth: 130,
            flex: 0.9,
            headerClassName: 'super-app-theme--header',
            valueGetter: ({ row }) => (row.IsActive ? 'Aktive' : 'Jo aktive'),
            renderCell: ({ row }) => {
                const isActive = Boolean(row.IsActive);
                return (
                    <span
                        style={{
                            padding: '3px 10px',
                            borderRadius: '999px',
                            fontSize: '0.75rem',
                            fontWeight: 700,
                            border: `1px solid ${isActive ? '#c3d8ce' : '#ddd5cf'}`,
                            background: isActive ? '#eef7f2' : '#f7f5f2',
                            color: isActive ? '#2a5a4c' : '#735f50',
                        }}
                    >
                        {isActive ? 'Aktive' : 'Jo aktive'}
                    </span>
                );
            },
        },
    ]), [role]);

    const fetchCityByState = async (stateID) => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Cities/getcitybystate', { headers, params: { stateid: stateID } });
            setCity(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);

            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    useEffect(() => {
        const headers = authHeader();
        axios.get(ApiLink.API_URL + 'states', { headers })
            .then((response) => {
                setState(response.data);
            })
            .catch((error) => {
                console.error(error);
            });
    }, []);

    useEffect(() => {
        fetchData();
        fetchRole();
        fetchPack();
    }, [])

    return (
        <div>
            {/* <Modal
                open={openPackModal}
                onClose={() => setOpenPackModal(false)}
                aria-labelledby="insert-modal-title"
                aria-describedby="insert-modal-description"
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Box sx={{ width: "30%", bgcolor: 'background.paper', borderRadius: '4px', boxShadow: 24, p: 4 }}>
                    {
                        insertType === "pack" ?
                            <p>Cakto pakon për këtë kompani</p>
                            :
                            <p>Cakto modulin për këtë kompani</p>
                    }
                    <hr></hr>
                    <FormControl sx={{ m: 1 }} variant="filled" style={{ width: "100%" }}>
                        <TextField
                            style={{ width: "100%" }}
                            id="outlined-read-only-input"
                            label="Kompania"
                            value={companyName}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                    </FormControl>
                   
                    <Autocomplete fullWidth sx={{ m: 1 }}
                        {...defaultPropsPack}
                        id="include-input-in-list"
                        includeInputInList
                        onChange={handleAutocompleteChangePack} // Shto funksionin onChange
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={insertType === "pack" ? "Zgjedh Pakon" : "Zgjedh modulin"}
                                variant="standard"
                            />
                        )}
                    />
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', m: 1 }}>
                        <MUI_Button variant="contained" color="secondary" onClick={() => { setOpenPackModal(false); }} sx={{ width: "45%" }}>Mbyll</MUI_Button>
                        <MUI_Button variant="contained" type="submit" onClick={(e) => { insertType === "pack" ? executeUpdatePack(e, "pack") : executeUpdatePack(e, "module") }} sx={{ width: "45%" }}>Ruaj</MUI_Button>
                    </Box>
                </Box>
            </Modal> */}
            <Modal
                open={openPackModal}
                onClose={() => setOpenPackModal(false)}
                aria-labelledby="insert-modal-title"
                aria-describedby="insert-modal-description"
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Box
                    sx={{
                        width: "30%",
                        bgcolor: 'background.paper',
                        borderRadius: '4px',
                        boxShadow: 24,
                        p: 4,
                    }}
                >
                    {insertType === "pack" ? (
                        <p>Cakto pakon për këtë kompani</p>
                    ) : (
                        <p>Cakto modulin për këtë kompani</p>
                    )}
                    <hr />
                    <FormControl sx={{ m: 1 }} variant="filled" style={{ width: "100%" }}>
                        <TextField
                            style={{ width: "100%" }}
                            id="outlined-read-only-input"
                            label="Kompania"
                            value={companyName}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                    </FormControl>
                    {/* <Autocomplete
                        fullWidth
                        sx={{ m: 1 }}
                        options={defaultPropsPack.options || []} // Kontrollo që options është një array
                        // getOptionLabel={(option) =>
                        //     typeof option === "string" ? option : option.name || ""
                        // }
                        id="include-input-in-list"
                        includeInputInList
                        onChange={handleAutocompleteChangePack}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={
                                    insertType === "pack" ? "Zgjedh Pakon" : "Zgjedh modulin"
                                }
                                variant="standard"
                            />
                        )}
                    /> */}
                    <Autocomplete
                        fullWidth
                        sx={{ m: 1 }}
                        {...defaultPropsPack}
                        id="include-input-in-list"
                        includeInputInList
                        onChange={handleAutocompleteChangePack}

                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={insertType === "pack" ? "Zgjedh Pakon" : "Zgjedh modulin"}
                                variant="standard"
                            />
                        )}
                    />

                    <Box sx={{ display: 'flex', justifyContent: 'space-between', m: 1 }}>
                        <MUI_Button
                            variant="contained"
                            color="secondary"
                            onClick={() => {
                                setOpenPackModal(false);
                            }}
                            sx={{ width: "45%" }}
                        >
                            Mbyll
                        </MUI_Button>
                        <MUI_Button
                            variant="contained"
                            type="submit"
                            onClick={(e) =>
                                insertType === "pack"
                                    ? executeUpdatePack(e, "pack")
                                    : executeUpdatePack(e, "module")
                            }
                            sx={{ width: "45%" }}
                        >
                            Ruaj
                        </MUI_Button>
                    </Box>
                </Box>
            </Modal>



            {/* Shfaqja  e modalit per editimin e te dhenave  */}
            {showEditModal && (
                <div className="edit-modal" style={{ padding: "50px" }}>
                    <form onSubmit={handleSubmit}>
                        <h3>Ndryshimi i Kompanisë</h3>

                        <div className="input-group mb-3">
                            <span className="input-group-text col-5 col-sm-5"># </span>
                            <input
                                className="form-control"
                                type="number"
                                id="CompanyID"
                                name="CompanyID"
                                value={formData.CompanyID}
                                onChange={handleInputChange}
                                disabled
                                autoComplete="off"
                            />
                        </div>
                        <div className="input-group mb-3">
                            <span className="input-group-text col-5 col-sm-5">Emri i Kompanisë</span>
                            <input
                                className="form-control"
                                type="text"
                                id="CompanyName"
                                name="CompanyName"
                                value={formData.CompanyName}
                                onChange={handleInputChange}
                                autoComplete="off"

                            />
                        </div>
                        <div className="input-group mb-3">
                            <span className="input-group-text col-5 col-sm-5">Numri Identifikues</span>
                            <input
                                className="form-control"
                                type="number"
                                id="IdentificationNumber"
                                name="IdentificationNumber"
                                value={formData.IdentificationNumber}
                                onChange={handleInputChange}
                                autoComplete="off"

                            />
                        </div>
                        <div className="input-group mb-3">
                            <span className="input-group-text col-5 col-sm-5">Numri i TVSH-së</span>
                            <input
                                className="form-control"
                                type="number"
                                id="VATNumber"
                                name="VATNumber"
                                value={formData.VATNumber}
                                onChange={handleInputChange}
                                autoComplete="off"
                            />
                        </div>
                        <div className="input-group mb-3">
                            <span className="input-group-text col-5 col-sm-5">Adresa</span>
                            <input
                                className="form-control"
                                type="text"
                                id="Address"
                                name="Address"
                                value={formData.Address}
                                onChange={handleInputChange}
                                autoComplete="off"

                            />
                        </div>
                        <div className="input-group mb-3">
                            <label className="input-group-text col-5 col-sm-5" htmlFor="stateSelect">Shteti </label>
                            <select
                                id="StateID"
                                name="StateID"
                                className="form-control"
                                value={formData.StateID}
                                onChange={(e) => { handleInputChange(e); fetchCityByState(e.target.value); }}
                            >
                                <option value="">-- Select State --</option>
                                {state.map((state) => (
                                    <option key={state.StateID} value={state.StateID}>
                                        {state.StateName}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="input-group mb-3">
                            <label className="input-group-text col-5 col-sm-5" htmlFor="stateSelect">Qyteti </label>
                            <select
                                id="CityID"
                                name="CityID"
                                className="form-control"
                                value={formData.CityID}
                                onChange={handleInputChange}
                            >
                                <option value="">-- Select City --</option>
                                {city.map((cities) => (
                                    <option key={cities.CityID} value={cities.CityID}>
                                        {cities.CityName}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="input-group mb-3">
                            <span className="input-group-text col-5 col-sm-5">Numri i Telefonit</span>
                            <input
                                className="form-control"
                                type="text"
                                id="PhoneNumbers"
                                name="PhoneNumbers"
                                value={formData.PhoneNumbers}
                                onChange={handleInputChange}
                                autoComplete="off"

                            />
                        </div>
                        <div className="input-group mb-3">
                            <span className="input-group-text col-5 col-sm-5">Fjalkalimi i sistemit të ATK-së</span>
                            <input
                                className="form-control"
                                type="text"
                                id="EdiPass"
                                name="EdiPass"
                                value={formData.EdiPass}
                                onChange={handleInputChange}
                                autoComplete="off"

                            />
                        </div>

                        <div className="input-group mb-3">
                            <span className="input-group-text col-5 col-sm-5">Fjalkalimi i sistemit të ARBK-së</span>
                            <input
                                className="form-control"
                                type="text"
                                id="ARBKPass"
                                name="ARBKPass"
                                value={formData.ARBKPass}
                                onChange={handleInputChange}
                                autoComplete="off"

                            />
                        </div>
                        <div className="input-group mb-3">
                            <span className="input-group-text col-5 col-sm-5">Email</span>
                            <input
                                className="form-control"
                                type="text"
                                id="Email"
                                name="Email"
                                value={formData.Email}
                                onChange={handleInputChange}
                                autoComplete="off"

                            />
                        </div>
                        <div className="input-group mb-3">
                            <span className="input-group-text col-5 col-sm-5">SMTP Client</span>
                            <input
                                className="form-control"
                                type="text"
                                id="SMTPClient"
                                name="SMTPClient"
                                value={formData.SMTPClient}
                                onChange={handleInputChange}
                                autoComplete="off"

                            />
                        </div>
                        <div className="input-group mb-3">
                            <span className="input-group-text col-5 col-sm-5">Fjalkalimi i Email-it</span>
                            <input
                                className="form-control"
                                type="password"
                                id="MailPass"
                                name="MailPass"
                                value={formData.MailPass}
                                onChange={handleInputChange}
                                autoComplete="off"

                            />
                        </div>
                        <div className="p-2 w-50 bd-highlight">
                            <img style={{ width: "50px", height: "50px" }}
                                src={ApiLink.PHOTO_URL + formData.CompanyLogo} />
                            <input className="m-2" type="file" onChange={imageUpload} />
                            {
                                showLogoAlert && (
                                    <p style={{ color: "red" }}>{showLogoTxt}</p>
                                )
                            }
                        </div>

                        <div className="input-group mb-3">
                            <span className="input-group-text col-5 col-sm-5">Komenti</span>
                            <textarea
                                className="form-control"
                                id="Comment"
                                name="Comment"
                                value={formData.Comment}
                                onChange={handleInputChange}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="IsActive">Deklarues i TVSH-së</label>
                            <input
                                type="checkbox"
                                id="VATDeclarant"
                                name="VATDeclarant"
                                checked={formData.VATDeclarant}
                                onChange={(event) =>
                                    setFormData({ ...formData, VATDeclarant: event.target.checked })
                                }
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="IsActive">Kompani Aktive</label>
                            <input
                                type="checkbox"
                                id="IsActive"
                                name="IsActive"
                                checked={formData.IsActive}
                                onChange={(event) =>
                                    setFormData({ ...formData, IsActive: event.target.checked })
                                }
                            />
                        </div>
                        <button type="submit" className="btn btn-success">Ndrysho</button>

                        <button
                            className="btn btn-secondary"
                            onClick={() => setShowEditModal(false)}
                        >
                            Anulo
                        </button>
                    </form>
                </div>
            )}
            <div style={{ marginBottom: "24px" }}>
                <CrudPageHeader
                    icon={MdAddBusiness}
                    title="Lista e Kompanive"
                    description="Forma e Kompanisë: Menaxhoni, editoni të dhënat e kompanisë sipas kërkeses."
                    tutorialUrl="https://www.youtube.com/@Accountree"
                    tutorialLabel="Shiko Tutorialin"
                    className="PITP__header"
                    action={
                        role === "acctree" ? (
                            <AddElementsButton
                                text="Krijo Kompani"
                                icon="bi bi-plus-circle"
                                className="button-68"
                                onClick={() => history.push("/configuration/newCompany")}
                            />
                        ) : null
                    }
                />
            </div>

            <ReusableServerDataGrid
                columns={companyGridColumns}
                rows={pagedData.map((item, index) => ({
                    ...item,
                    id: item.CompanyID ?? `company-row-${paginationModel.page}-${index}`,
                    rowInfo: item,
                }))}
                onEdit={(item) => { handleEdit(item); fetchCityByState(item.StateID); }}
                showEditAction={role === "acctree" || role === "admin"}
                showDeleteAction={false}
                showViewAction={false}
                actionsMinWidth={110}
                actionsFlex={0.8}
                height={620}
                rowCount={filteredData.length}
                loading={loading}
                paginationModel={paginationModel}
                setPaginationModel={setPaginationModel}
                sortModel={sortModel}
                setSortModel={setSortModel}
                filterModel={filterModel}
                setFilterModel={setFilterModel}
                quickFilter={quickFilter}
                setQuickFilter={setQuickFilter}
                getExportRows={async () => filteredData.map((item, index) => ({
                    ...item,
                    rowNumber: index + 1,
                }))}
            />
        </div>
    )
}
